import styled, {css} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {breakpoint, colors} from 'theme';

export const ColumnsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: unset;
    margin-bottom: 40px;
    margin-top: 36px;

    @media (min-width: ${breakpoint.tablet}) {
        gap: 40px;
    }
`;

export const Column = styled.div`
    margin-bottom: 16px;
    flex: 1;
    min-width: 250px;
`;

export const ColumnElement = styled.div`
    margin-bottom: 16px;
`;

export const Typography = styled.div<{highlighted?: boolean}>`
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
    ${(p) =>
        p.highlighted &&
        css`
            background: ${colors.brandLight};
            padding: 6px 10px;
            border-radius: 6px;
            width: fit-content;
        `}
`;

export const Title = styled(Typography)`
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
`;

export const HeaderTypography = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textSecondary};
    margin-bottom: 6px;
`;

export const SpinnerContainer = styled.div`
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;

    & > * {
        width: 120px;
    }
`;

export const RejectButton = styled(Button)`
    border-color: ${colors.warnings};
    color: ${colors.warnings};

    & > * {
        gap: 8px;
    }

    &:hover:not(:disabled) {
        border-color: ${colors.warnings};
    }
`;

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colors.textPrimary};
    text-align: center;
    gap: 10px;

    & > p {
        font-size: 15px;
        font-weight: 500;
        margin: 0;
    }

    & > div {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        width: 100%;

        & > * {
            flex: 1;
        }
    }
`;

export const Back = styled(Button)``;
